import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnablePickListHtmlEditor = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enablePickListHtmlEditor);
};
